import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  activateUser,
  addClientUser,
  deActivate,
  deleteUserV1,
  getClientUserListV1,
  updateClientUser,
} from "api/userV1.api";
import { notificationController } from "controllers/notificationController";
import { IClientUser, IClientUserById } from "domain/ClientInterfacesV1";

export interface UserSlice {
  erpUserList: IClientUserById[] | null;
  erpClientUserList: IClientUserById[] | null;
}

const initialState: UserSlice = {
  erpUserList: null,
  erpClientUserList: null,
};

export const doGetClientUserV1 = createAsyncThunk("Users/GetClientUsers/V2", async () =>
  getClientUserListV1().then((res: IClientUserById[]) => {
    return res;
  })
);

export const doAddClientUserV1 = createAsyncThunk(
  "Users/AddClientUser/V2",
  async (clientUserPayload: IClientUser, { dispatch }) =>
    addClientUser(clientUserPayload).then((res) => {
      // dispatch(doGetClientUserV1());
      return res;
    })
);
export const doUpdateClientUserV1 = createAsyncThunk(
  "Users/UpdateClientUser/V2",
  async (clientUserPayload: IClientUser, { dispatch }) =>
    updateClientUser(clientUserPayload.id, clientUserPayload).then((res) => {
      // dispatch(doGetClientUserV1());
      return res;
    })
);

export const doDeleteClientUserV1 = createAsyncThunk(
  "Users/DeleteClientUser/V2",
  async (garmentId: string, { dispatch }) => {
    deleteUserV1(garmentId).then(
      (res) => {
        notificationController.error({
          message: "User deleted successfully.",
        });
        dispatch(doGetClientUserV1());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

export const doDeActivateClientUserV1 = createAsyncThunk(
  "erpUser/doDeActivateClientUser",
  async (garmentId: string, { dispatch }) => {
    deActivate(garmentId).then(
      (res) => {
        notificationController.error({
          message: "User deactivated successfully.",
        });
        dispatch(doGetClientUserV1());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);
export const doActivateClientUserV1 = createAsyncThunk(
  "erpUser/doActivateClientUser",
  async (garmentId: string, { dispatch }) => {
    activateUser(garmentId).then(
      (res) => {
        notificationController.error({
          message: "Client User activated successfully.",
        });
        dispatch(doGetClientUserV1());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

const erpUserSliceV1 = createSlice({
  name: "erpUserV1",
  initialState,
  reducers: {
    clearUserListV1: (state) => {
      state.erpUserList = null;
    },
    clearClientUserListV1: (state) => {
      state.erpClientUserList = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetClientUserV1.fulfilled, (state, action) => {
      state.erpClientUserList = action.payload;
    });
  },
});

export const {
  clearUserListV1,
  clearClientUserListV1,
} = erpUserSliceV1.actions;

export default erpUserSliceV1.reducer;
